
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class CopyProcessToOthersModal extends Vue {

    @Prop() layerList: OM.LayerComposition[];
    @Prop() productionPhase: string;
    @Prop() layer: OM.LayerComposition;

    @Prop() allProductionProcesses: OM.ProductionProcessListVM[];
    @Prop() currentProductionProcesses: OM.FabricProductionProcess[];
    @Prop() countries: OM.TextIdentifier[];

    @Prop() saveCallback: (selectedLayersToCopy: string[]) => void;

    selectedLayersToCopy: string[] = [];

    created() {}

    get disabled() {
        return this.selectedLayersToCopy.length == 0;
    }

    get rawMaterials() {
        var ris = [];
        for (let name in this.grouped) {
            for (let materialId in this.grouped[name]) {
                const materialData = this.grouped[name][materialId][0].rawMaterial;
                const productionCountry = this.grouped[name][materialId][0].productionCountry;
                if (!ris.some(material => material.identifier === materialData.identifier)) {
                    var obj = {
                        identifier: materialData.identifier,
                        rawMaterial: materialData,
                        productionCountry: productionCountry
                    }
                    ris.push(obj);
                }
            }
        }
        return ris;
    }

    get grouped() {
        if(this.currentProductionProcesses.length == 0)
            return [];

        let groupedByName = this.currentProductionProcesses
        .filter( x => !x.rawMaterialIndipendent)
        .filter( x => x.productionPhase.text == this.productionPhase)
        // .filter( x => x.emissionCalculation == null)
        .reduce((acc, item) => {
            if (!acc[item.name]) {
                acc[item.name] = [];
            }
            acc[item.name].push(item);
            return acc;
        }, {});

        // Secondo passaggio: raggruppamento per "rawMaterial" all'interno di ogni gruppo "name"
        for (let name in groupedByName) {
            groupedByName[name] = groupedByName[name].reduce((acc, item) => {
                let key = item.rawMaterial.identifier;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
        }

        return groupedByName;
    }

    toggleLayerFromList(item: string) {
        var existingIndex = this.selectedLayersToCopy.indexOf(item);
        if(existingIndex == -1)
            this.selectedLayersToCopy.push(item);
        else
            this.selectedLayersToCopy.splice(existingIndex, 1);
    }

    save() {
        this.saveCallback(this.selectedLayersToCopy);
    }
}
